export default function PromiseBar() {
  const items = ['Cleaner Homes', 'Cleaner Businesses', 'Cleaner Communities'];

  return (
    <section className="w-full bg-primary-900 py-8 md:py-10">
      <div className="container-content">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-0">
          {items.map((item, i) => (
            <>
              {i > 0 && (
                <span className="hidden sm:block text-background-600 mx-6 text-lg">|</span>
              )}
              <span className="font-heading font-semibold text-body-lg md:text-heading-md text-background-50 tracking-tight">
                {item}
              </span>
            </>
          ))}
        </div>
      </div>
    </section>
  );
}